<template>
  <div id="home" class="page-container">
    <md-app md-mode="fixed">
      <!-- The title bar -->
      <md-app-toolbar class="md-primary">
        <md-button class="md-icon-button" @click="toggleMenu">
          <md-icon md-src="/static/img/icons/logo.svg" class="md-size-2x"/>
        </md-button>
        <span class="md-title">Quick Tourney</span>

        <div class="md-toolbar-section-end">
          <div v-if="currentUser">
            <md-button @click="logOut">
              <span>Logout</span>
              <md-icon>person</md-icon>
            </md-button>
          </div>
          <div v-else>
            <md-button @click="showLoginDialog = true">Login</md-button>
          </div>
        </div>
      </md-app-toolbar>

      <!-- The Main Menu (slide-out drawer) place holder -->
      <md-app-drawer :md-active.sync="menuVisible">
        <MainMenu/>
      </md-app-drawer>

      <!-- The body of the page -->
      <md-app-content>
        <router-view name="body"/>
      </md-app-content>
    </md-app>

    <!-- The bottom navigation bar -->
    <md-bottom-bar md-type="shift" md-sync-route>
      <md-bottom-bar-item v-if="currentUser" md-label="Mine" md-icon="domain" to="/myTournaments"></md-bottom-bar-item>
      <!--
      <md-bottom-bar-item md-sync-route md-label="Favorite" md-icon="favorite"></md-bottom-bar-item>
      -->
      <md-bottom-bar-item md-label="Public" md-icon="public" to="/publicTournaments"></md-bottom-bar-item>
    </md-bottom-bar>

    <!-- The popup notification component placeholder -->
    <md-snackbar
      :md-position="'center'"
      :md-active.sync="showNotification"
      :md-duration="5000"
      md-persistent
    >
      <span>{{notification}}</span>
    </md-snackbar>

    <!-- The login dialog -->
    <login-dialog :show="showLoginDialog" @onClose="showLoginDialog = false"/>
  </div>
</template>

<script>
import MainMenu from "@/components/MainMenu.vue";
import LoginDialog from "@/components/dialogs/loginDialog.vue";

export default {
  name: "Home",
  components: {
    MainMenu,
    LoginDialog
  },

  data: function() {
    return { showLoginDialog: false, showNotification: false };
  },

  computed: {
    currentUser: {
      get() {
        return this.$store.state.currentUser;
      }
    },

    /*
    theme: {
      get() {
        return this.currentUser ? "loggedIn" : "default";
      }
    },
    */

    menuVisible: {
      get() {
        return this.$store.state.menuVisible;
      },
      set(value) {
        this.toggleMenu();
      }
    },

    notification: {
      get() {
        return this.$store.state.notification;
      },
      set(value) {
        this.$store.commit("setNotification", value);
      }
    }
  },

  watch: {
    notification(value) {
      this.showNotification = true;
    }
  },

  methods: {
    toggleMenu() {
      this.$store.commit("toggleMenuVisibility");
    },

    logOut() {
      this.$store.commit("setCurrentUser", undefined);
      this.$router.push({ path: "/publicTournaments" });
      this.notification = "You are now logged out";
    }
  },
  created() {
    this.$router.push({ path: "/publicTournaments" });
  }
};
</script>

<style lang="scss" scoped>
/*
@import "~vue-material/dist/theme/engine"; // Import the theme engine

@include md-register-theme(
  "default",
  (
    primary: md-get-palette-color(blue, A200),
    accent: md-get-palette-color(red, A200),
    theme: dark
  )
);

@include md-register-theme(
  "loggedIn",
  (
    primary: md-get-palette-color(red, A200),
    accent: md-get-palette-color(blue, A200),
    theme: dark
  )
);

@import "~vue-material/dist/theme/all"; // Apply the theme
*/

.md-app {
  border: 1px solid rgba(#000, 0.12);
}

// Demo purposes only
.md-drawer {
  width: 230px;
  max-width: calc(100vw - 125px);
}

.md-content {
  justify-content: center;
  align-items: center;
  padding: 0px;
  height: calc(100vh) !important;
}

.md-bottom-bar {
  position: fixed;
  left: 0px;
  bottom: 0px;
}
</style>


// WEBPACK FOOTER //
// Home.vue?6f2e35ca